import styled from "@emotion/styled";

/**
 * Shared layout for the investment edit tabs so the modal keeps a constant
 * height and the save button stays pinned to the bottom. On desktop each tab
 * has a fixed content height; overflowing content (e.g. symbol search results)
 * scrolls inside the fields area instead of resizing the modal.
 */
const TAB_CONTENT_HEIGHT = 380;

export const EditTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing(4)};

  ${({ theme }) => theme.breakpoints.up("sm")} {
    height: ${TAB_CONTENT_HEIGHT}px;
  }
`;

export const EditTabFields = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.spacing(6)};

  ${({ theme }) => theme.breakpoints.up("sm")} {
    grid-template-columns: 1fr 1fr;
    align-content: start;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }
`;

export const EditTabActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${({ theme }) => theme.spacing(6)};

  ${({ theme }) => theme.breakpoints.up("sm")} {
    margin-top: auto;
    flex-shrink: 0;
  }
`;
